export const DOWNLOAD_GATE_CLOSABLE_POP_TYPE = "5";
export const DOWNLOAD_GATE_FORCE_POP_TYPE = "6";

type DownloadGateCandidate = {
  isPop?: number;
  popType?: string;
  updateTime?: number;
};

export const isDownloadGatePopType = (popType?: string): boolean =>
  popType === DOWNLOAD_GATE_CLOSABLE_POP_TYPE ||
  popType === DOWNLOAD_GATE_FORCE_POP_TYPE;

export const isClosableDownloadGatePopType = (popType?: string): boolean =>
  popType === DOWNLOAD_GATE_CLOSABLE_POP_TYPE;

export const isEnabledDownloadGateCandidate = (
  item?: DownloadGateCandidate | null,
): boolean => item?.isPop === 1 && isDownloadGatePopType(item?.popType);

export const pickHighestPriorityDownloadGateItem = <
  T extends DownloadGateCandidate,
>(
  items: T[] | null | undefined,
): T | null => {
  if (!items?.length) return null;

  const matched = items
    .filter((item) => isEnabledDownloadGateCandidate(item))
    .sort((a, b) => (b?.updateTime || 0) - (a?.updateTime || 0));

  return matched[0] || null;
};

